import { createAsyncThunk } from "@reduxjs/toolkit";
import otherService from "../../Services/OtherService";
import { ResponseMessageHandler } from "../../globals/components/notification";

export const getcronjobetails = createAsyncThunk(
  "other/getcronjobetails",
  async (data, thunkAPI) => {
    try {
      let res = await otherService.getcronjobetailsAPI();
      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const setcronjobDuration = createAsyncThunk(
  "other/setcronjobDuration",
  async (data, thunkAPI) => {
    try {
      let res = await otherService.cronjobDurationAPI({
        ...data,
      });
      thunkAPI.dispatch(getcronjobetails());
      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getSystemPrompt = createAsyncThunk(
  "other/getSystemPrompt",
  async (data, thunkAPI) => {
    try {
      let res = await otherService.getSystemPromptAPI({
        ...data,
      });

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const setSystemPrompt = createAsyncThunk(
  "other/setSystemPrompt",
  async (data, thunkAPI) => {
    try {
      let res = await otherService.setSystemPromptAPI({
        ...data,
      });

      thunkAPI.dispatch(getSystemPrompt());
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
